import React from 'react';
import styled from 'styled-components';
import {store} from '../stores/mainStore';
import {motion} from 'framer-motion';
import {DarkPage} from "./TopBarElements";
import {Bkg} from './Elements';

export const DarkPageModal = styled(p => {
	return <DarkPage 
		className = {p.className}
		top={0}
	>
		{p.children}
	</DarkPage>
})`
	position: initial;
	z-index: initial;
`;

export const Popup = styled(p => {return (
	<motion.div 
		className={p.className}
		initial={{ scale: 0 }}
		animate={{ scale: 1 }}
		transition={{ delay: 0.4, duration: 0.5, type: 'spring', stiffness: 300, damping: 18, mass: 1 }}
		onAnimationComplete={p.onAnimationComplete}
	>
		<Bkg src={p.fullPath ? p.bkg : `assets/languages/${store.getLanguage}/${p.bkg}.png`}/>
		{p.children}
	</motion.div>
)})`
	position: relative;
	width: 95%;
	height: ${p => p.h}vw;
	//background: url(${p => `assets/languages/${store.settings.language}/${p.bkg}.png`}) center/100% no-repeat;
	color: white;
	font-weight: 600;
	text-align:center;

	@media (min-aspect-ratio: 9/15) {
		transform: scale(0.7) !important;
	}
`;

export const SpreadedContent = styled.div`
	position: relative;
	display:flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	height: ${p => p.h}vw;
	margin: ${p => p.t || 0}vw auto 0;
`;